// DE: Etwas warten, bevor die Blob-Adresse freigegeben wird; manche Browser laden sonst nichts.
// EN: Wait a little before releasing the blob URL; otherwise some browsers download nothing.
const RELEASE_DELAY_MS = 1000;

/**
 * DE: Text als Datei herunterladen (JSON), ohne Server.
 * EN: Download text as a file (JSON), without a server.
 */
export function downloadJson(text: string, fileName: string): void {
  const url = URL.createObjectURL(new Blob([text], { type: 'application/json' }));
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  setTimeout(() => URL.revokeObjectURL(url), RELEASE_DELAY_MS);
}
